import React from 'react'
import { css } from 'aphrodite'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'

import Sitemap from '../partials/Sitemap'
import GameBox from './partials/gamebox'

import gameList from './games.json'

import style from './style'

const sitemapHeader = [
  { url: '/', title: 'Home' },
  { url: '/games', title: 'Games' }
]

export class GameScreen extends React.Component {
  render () {
    return [
      <Sitemap key={0} sitemap={sitemapHeader} />,
      <section key={1} className={css(style.main.section)}>
        <Container>
          <Row>
            <Col xs='12' md='9'>
              {gameList.map((item, index, arr) => {
                if (index < arr.length - 1) {
                  return [
                    <GameBox key={`gb_${index}`} {...item} />,
                    <hr
                      key={`hr_${index}`}
                      className={css(style.main.spacer)}
                    />
                  ]
                }

                return <GameBox key={`gb_${index}`} {...item} />
              })}
            </Col>
            <Col xs='12' md='3'>
              <h4 className={css(style.sidebar.h4)}>
                <strong className={css(style.sidebar.h4Bold)}>Join us!</strong>{' '}
                Up
              </h4>
              <p className={css(style.sidebar.p)}>
                <em>
                  <Link to='/signup' className={css(style.sidebar.link)}>
                    Sign up
                  </Link>
                  &nbsp;if you're running a server on any of those games.
                </em>
              </p>
              <hr className={css(style.main.spacer)} />
            </Col>
          </Row>
        </Container>
      </section>
    ]
  }
}

export default GameScreen



// WEBPACK FOOTER //
// ./src/components/Games/index.js